import { z } from 'zod';
import { PARTNER_COCKPIT_MIN_PASSWORD_LENGTH, partnerCockpitRequiredNameFieldSchema } from '../user-management/auth.js';
import { phoneNumberSchema } from '../user-management/phoneNumber.js';
export const accountDetailsStepSchema = z.object({
    firstName: partnerCockpitRequiredNameFieldSchema,
    lastName: partnerCockpitRequiredNameFieldSchema,
    phoneNumber: phoneNumberSchema(),
    // Absent on a revisit: the password is set the first time through and left alone after, so returning does not
    // rotate it and log the session out mid-flow.
    password: z.string().min(PARTNER_COCKPIT_MIN_PASSWORD_LENGTH).optional(),
});
export const accountDetailsResponseSchema = z.object({
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    phoneNumber: z.string().optional(),
    hasPassword: z.boolean(),
});
